<template>
  <div class="no-data py-0 mt-3 px-0">
    <div class="container px-0">
      <slot></slot>
      <div class="image-container position-absolute">
        <h4 data-test-name="no-data-title">{{title}}</h4>
        <span data-test-name="no-data-text" class="text">{{text}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    title: {
      type: String,
      default: 'No data found'
    },
    text: {
      type: String,
      default: 'There is currently no data available for this component'
    }
  }
}
</script>

<style scoped lang="scss">

  .no-data{
    position: relative;
    font-weight: 500;
    text-align: center;
    height: auto;
    width: 100%;
    display: flex;
    align-content: center;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    min-height: 110px;
    min-width: 348px;
    .container{
      display: flex;
      align-items: center;
      justify-content: center;
      .image-container{
        left: 0;
        right: 0;
      }
      img{
        position: relative;
        display: flex;
        align-items: flex-start;
        align-content: flex-start;
        justify-content: flex-start;
        width: 100%;
        opacity: 0.2;
      }
    }
  span{
    color: $color-primary;
    padding: 0.65em;
    border-radius: 50%;
    z-index: 10;
    max-width: 85%;
    display: inline-block;
    margin: 0 auto;
    position: relative;
  }
    .text{
      margin-bottom: 0;
    }
  h4{
    padding: 0;
    margin: 0;
    z-index: 10;
    position: relative;
    font-weight: 600;
  }
    .icon{
      font-size: 1.75em;
      position: relative;
      left: -5px;
      padding: 0;
      font-weight: 600;
      color: $color-dark;
      top: -1px;
      margin-bottom: 0.45em;
    }
  }
</style>
